import React, { useEffect, useState, useContext } from 'react';
import './Drop.css';
import { PriceContext } from '../Context/PriceContext'; 

const Drop = ({ className, options, onSelect, icon  }) => {
  const { paymentData, setPaymentData } = useContext(PriceContext);
  const [selectedOption, setSelectedOption] = useState('');

  useEffect(() => {
    const defaultColor = '#d0dcdf'; 
    const dropdown = document.getElementById(className);
    if (dropdown) {
      const defaultOption = dropdown.querySelector('option');
      if (defaultOption) {
        defaultOption.style.color = defaultColor;
      }
    }
  }, [className]);

  const calculateDeadline = (option) => {
    const now = new Date();
    const utcDate = new Date(now.toUTCString());
    let daysToAdd;
    switch (option) {
      case "Same Day (4-6hrs)":
        return formatToEST(utcDate);
      case "Next Day (24hrs)":
        daysToAdd = 1;
        break;
      case "Priority (72 hours)":
        daysToAdd = 3;
        break;
      case "Standard (5-7 days)":
        daysToAdd = 7;
        break;
      default:
        daysToAdd = 0;
    }
    utcDate.setDate(utcDate.getDate() + daysToAdd);
    return formatToEST(utcDate);
  };

  const formatToEST = (date) => {
    const options = { timeZone: 'America/New_York', year: 'numeric', month: 'long', day: 'numeric' };
    const formatter = new Intl.DateTimeFormat('en-US', options);
    return formatter.format(date);
  };

  const handleChange = (e) => {
    const option = e.target.value;
    setSelectedOption(option);
    const deliveryDate = calculateDeadline(option);
    setPaymentData({
      ...paymentData,
      deliveryTurnaround: option,
      deadline: deliveryDate 
    });
    onSelect(option);
  };

  return (
    <div className={`drop-container ${className}`}>
      <img src={icon} alt="icon" className="drop-icon" />

      <select id={className} onChange={handleChange}>
        {/* Placeholder option for specific dropdowns */}
        {className === 'DocumentType' && (
          <option value="">Document Type</option>
        )}
        {className === 'DeliveryTurnaround' && (
          <option value="">Completion Date</option>
        )}

        {/* Render all options dynamically */}
        {options.map((option, index) => (
          <option key={index} value={option}>
            {option}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Drop;